import { useRef, useState } from 'react';
import { Button, Tooltip } from '@nazka/nazka.mapframe.components';
import { faHourglass } from '@fortawesome/pro-solid-svg-icons';

import { useOnClickOutside } from '@services/hooks.service';
import { useTranslation } from '@utils/i18n/i18n.consumers';
import { useOfflineUploadQueue } from '@utils/OfflineUploadQueue/OfflineUploadQueueProvider';

import './upload-notifications.styl';

function UploadNotifications() {
  const { t } = useTranslation();
  const { count } = useOfflineUploadQueue();

  const [showInfo, setShowInfo] = useState(false);

  const ref = useRef(null);

  useOnClickOutside(ref, () => setShowInfo(false));

  // Don't render if there are no pending uploads
  if (count === 0) {
    return null;
  }

  return (
    <div ref={ref} className="upload-notifications">
      <Tooltip
        isOpen={showInfo}
        className="upload-notifications__tooltip"
        tooltip={t('Stories and plans saved offline will be uploaded automatically when back online.')}
        id="upload-notifications-tooltip"
      >
        <Button
          onClick={() => setShowInfo(prev => !prev)}
          icon={faHourglass}
          rootElProps={{ 'data-tooltip-id': 'upload-notifications-tooltip' }}
          hover={false}
        />
      </Tooltip>
      <span className="upload-notifications__badge">{count}</span>
    </div>
  );
}

export default UploadNotifications;
